import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import Statistics from "./statistics";
import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import ShareModal from "../../../components/ShareModal";
import DataTable from "../../../components/Tables/tables";
import URL from "../../../config/api";
import axios from "../../../config/axios";

class EvaluationList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      statisticsModal: false,
      loading: true,
      selectedActivityId: null,
      // showShareModal: false,
      // currentActivityId: null,
      showShareQrModal: false,
      urlShareQrModal: undefined
    };

    this.error = this.error.bind(this);
    this.insertAction = this.insertAction.bind(this);
    this.allocateAction = this.allocateAction.bind(this);
    this.printAction = this.printAction.bind(this);
  }

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  };

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    let obj = {
      user_id: this.props.user.user.id,
      ability_id: 0,
      difficulty_level_id: 0,
      year: 0,
      live: false,
      type_id: 4
    };

    axios
      .post(`${URL.api}activity/activity/list`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState(
          {
            list: resp.data.data
          },
          () => {
            this.setState({
              loading: false
            });

            this.state.list.forEach(obj => this.renameKey(obj, "name", "nome"));
            this.state.list.forEach(obj =>
              this.renameKey(obj, "description", "descrição")
            );
          }
        );
      });
  }

  renameKey = (obj, oldKey, newKey) => {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  };

  insertAction = () => {
    this.props.history.push("/evaluation/create");
  };

  allocateAction = row => {
    this.props.history.push(`/evaluation/allocate/${row.id}`);
  };

  reportAction = row => {
    this.setState({ statisticsModal: true, selectedActivityId: row.id });
  };

  shareAction = row => {
    // Fazer uma req GET com as opções daquele dado
    // this.setState({ showShareModal: true, currentActivityId: row.id });
  };

  getSelected = selecteds => {
    this.setState({
      // selectedQuestions: selecteds
    });
  };

  printAction = row => {
    let objAllocate = {
      activity_id: row.id,
      room_id: 0,
      user_id: 0
    };

    axios
      .post(`${URL.api}activity/allocate/list`, objAllocate, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.data.length > 0) {
            this.props.history.push(`/evaluation/print/${row.id}`);
          } else {
            toastr.error(
              "Erro",
              "Você precisa alocar a lista em alguma turma primeiro."
            );
          }
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  };

  deleteAction = arrayRow => {
    for (const row of arrayRow) {
      let obj = {
        id: row
      };
      axios
        .post(`${URL.api}activity/activity/delete`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {});
    }
  };

  render() {
    return (
      <>
        {this.state.statisticsModal && (
          <Statistics
            show
            onClose={() => this.setState({ statisticsModal: false })}
            activity_id={this.state.selectedActivityId}
            currentRoute={this.props.currentRoute}
            title={
              this.state.list.find(
                item => item.id === this.state.selectedActivityId
              )?.nome
            }
          />
        )}
        <ShareModal
          show={this.state.showShareQrModal}
          onClose={() => this.setState({ showShareQrModal: false })}
          link={this.state.urlShareQrModal}
        />
        <div className="animated fadeIn">
          {this.state.loading ? (
            <Loading top="45" left="50" />
          ) : (
            <Row>
              <Breadcrumb current={this.props.currentRoute} />
              {this.state.list ? (
                <div id="list">
                  <DataTable
                    responsiveCards
                    list={this.state.list}
                    path="/evaluation/create/"
                    title="Avaliações"
                    header={[
                      { name: "id", denomination: "ID" },
                      { name: "nome", denomination: "Nome" },
                      { name: "descrição", denomination: "Descrição" }
                    ]}
                    insert
                    delete
                    insertAction={this.insertAction}
                    getSelected={this.getSelected}
                    action
                    btnEdit
                    btnPrint
                    btnAllocate
                    btnReport
                    btnShareQr={row => {
                      this.setState({
                        showShareQrModal: true,
                        urlShareQrModal: `${window.location.origin}/questionlist/do/${row.id}`
                      });
                    }}
                    allocateAction={this.allocateAction}
                    reportAction={this.reportAction}
                    printAction={this.printAction}
                    deleteAction={this.deleteAction}
                  />
                </div>
              ) : (
                <Loading />
              )}
            </Row>
          )}
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EvaluationList);
